import React from 'react';
import { Typography } from '../typography';
import Icons from '@/const/icons';
import { Icon } from '../icon';
import clsx from 'clsx';

interface Props {
	message: string;
	className?: string;
	classNameIcon?: string;
}

export const FunnelEmptyScreen: React.FC<Props> = ({
	message,
	className,
	classNameIcon,
}) => {
	return (
		<div className={`text-center m-auto ${className}`}>
			<Icon
				src={Icons.funnelEmpty}
				className={clsx('!h-[140px] m-auto', classNameIcon)}
			/>
			<Typography
				type="regular-18"
				className="text-center"
			>{`${message} `}</Typography>
			<br />
			<Typography type="regular-18">
				Please try adjusting your filter.
			</Typography>
		</div>
	);
};
